import {makeLoader} from './makeLoader';

let visitor = {
    activeUserRole: null,
    creditsAvailable: 0,
    currentClientid: undefined,
    hasReachedConcurrentMeetingLimit: false,
    isAdmin: false,
    isConsumer: false,
    isExpert: false,
    isIpAuthUser: false,
    isLoggedIn: false,
    isManagerUser: false,
    isOwner: false,
    isPartnerUser: false,
    isUser: false,
    isWebinarUser: false,
    isWhitelabel: false,
    landingPage: undefined,
}
visitor = makeLoader('/visitor/get.json', 'Visitor', visitor);

export {visitor};
